import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import {
  Modal, Button, Select, Input,
} from 'antd';
import { useForm } from 'react-hook-form';
import { isMobile } from 'react-device-detect';

const { TextArea } = Input;
interface modalAdviseProps{
  closeModal: any,
  modalState: any,
  type: string,
  intl: any,
  pacienteSelected: any,
}

function ModalAdvise({
  closeModal, modalState, type, intl, pacienteSelected
}:modalAdviseProps) {
  const [adviceState, setAdviceState] = useState('');
  const [charsLeft, setCharsLeft] = useState(160);
  const [messageText, setMessageText] = useState('');
  const deviceMobile = !isMobile;

  const {
    register, setValue, errors, control,
  } = useForm({
    mode: 'onTouched',
    defaultValues: {
      tel: '',
      message: '',
      email: '',
    },
  });

  useEffect(() => {
    register('tel', {
      required: {
        value: true,
        message: '¡ Introduzca el número de telefono !',
      },
    });
    register('email', {
      required: {
        value: true,
        message: '¡ Introduzca el email !',
      },
    });
    register('message', {
      required: {
        value: true,
        message: '¡ Escriba un mensaje o seleccione un plantilla para cargarlo !',
      },
    });
  }, [register]);

  function closeModalWindow() {
    setMessageText('');
    closeModal();
    setTimeout(() => setAdviceState(''), 200);
  }

  function handleTemplate(value: string) {
    setValue('message', value, { shouldValidate: true, shouldDirty: true });
  }

  function handleChange(e:React.ChangeEvent<HTMLTextAreaElement>) {
    setMessageText(e.target.value);
    const currentText = e.target.value;
    const characterCount = currentText.length;
    const maxChars = 160;
    const unitCount = maxChars - characterCount;
    setCharsLeft(unitCount);
  }

  useEffect(() => {
    if (type === 'sms') {
      setAdviceState('sms');
    }
    if (type === 'email') {
      setAdviceState('email');
    }
  }, [type]);

  const headerModal = (
    <div>
      <div className="ant-modal-title">
        { (() => {
          if (adviceState === '') {
            return intl.formatMessage({ id: 'pacientes.generic.titles.advises' });
          }
          if (adviceState == 'sms') {
            return 'Avisar por SMS';
          }
          return 'Avisar por Email';
        })()}

      </div>
      <div className="modal-subtitle">{pacienteSelected?.nombre_completo} / Encargo - Nº 9588864029 / Graduado</div>
    </div>
  );

  return (
    <>
      <Modal
        title={headerModal}
        visible={modalState}
        onCancel={() => {
          if (!deviceMobile) {
            closeModal();
            setMessageText('');
          } else closeModalWindow();
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              if (!deviceMobile) {
                closeModal();
                setMessageText('');
              } else if (adviceState !== '') setAdviceState('');
              else closeModalWindow();
            }}
          >
            Cancelar
          </Button>,
          adviceState !== ''
            ? (
              <Button type="primary">
                Enviar
              </Button>
            )
            : null,
        ]}
        width={adviceState !== '' ? 588 : 656}
        className="modalNewTest"
      >
        {adviceState === ''
          ? (
            <div className="modalContent">
              <div className="modalOptions" onClick={() => setAdviceState('sms')}>
                <h3 className="tests">SMS</h3>
                <div className="testImg">
                  <img src="/img/pacientes/SMS.svg" alt="Optometria" />
                </div>
              </div>
              <div className="modalOptions" onClick={() => setAdviceState('email')}>
                <h3 className="tests">Email</h3>
                <div className="testImg">
                  <img src="/img/pacientes/Email.svg" alt="Contactologia" />
                </div>
              </div>
            </div>
          )
          : (
            <div className="flexCol">
              <div className="topSms marginBot16">
                <div className="flexCol">
                  {adviceState === 'sms'
                    ? (
                      <>
                        <h4 className="marginBot8">Número de teléfono</h4>
                        <input
                          className="roundedBord ant-input"
                          type="number"
                          ref={register}
                          name="tel"
                          placeholder="Móvil"
                          style={{ width: '100%', height: 40 }}
                        />
                        <div>
                          {(errors.tel && (
                          <p className="errors">{errors.tel.message}</p>
                          ))
                  }
                        </div>
                      </>
                    )
                    : (
                      <>
                        <h4 className="marginBot8">Email</h4>
                        <input
                          className="roundedBord ant-input"
                          type="email"
                          ref={register}
                          name="email"
                          placeholder="Email"
                          style={{ width: '100%', height: 40 }}
                        />
                        <div>
                          {(errors.email && (
                          <p className="errors">{errors.email.message}</p>
                          ))
                  }
                        </div>
                      </>
                    )
            }
                </div>
                <div className="flexCol">
                  <h4 className="marginBot8">Plantilla</h4>
                  <Select
                    getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                      ? trigger.parentElement : null)}
                    defaultValue="Ninguna"
                    size="large"
                    style={{ width: '100%' }}
                    onSelect={(value: string) => handleTemplate(value)}
                  />
                </div>
              </div>
              <div className="bodySms flexCol">
                <div className="flexRow spaceBetween marginBot8">
                  <h4>Mensaje</h4>
                  {adviceState === 'sms' ? (
                    <span className="charsLeft">
                      {charsLeft}
                      {' '}
                      caracteres disponibles
                    </span>
                  ) : null}
                </div>
                <TextArea
                  {... adviceState === 'sms' ? { maxLength: 160 } : ''}
                  style={{ height: 120, resize: 'none' }}
                  onChange={handleChange}
                  value={messageText}
                />
                <div>
                  {(errors.message && (
                  <p className="errors">{errors.message.message}</p>
                  ))
              }
                </div>
              </div>
            </div>
          )
        }
      </Modal>
    </>
  );
}


export default injectIntl(ModalAdvise);
